import Slide, { SlideProps } from '@mui/material/Slide'

export type ITransitionProps = Omit<SlideProps, 'direction'>

export const TransitionUp = (props: ITransitionProps) => {
  return <Slide {...props} direction="up" />
}
